import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoginRegisterRoutingModule } from './login-register-routing.module';
import { LoginRegisterComponent } from './components/login-register/login-register.component';
import { RegisterEmailComponent } from './components/register-email/register-email.component';
import { LoginComponent } from './components/login/login.component';

import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { RegModalComponent } from './components/reg-modal/reg-modal.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { EmailVerifiedComponent } from './components/email-verified/email-verified.component';
import { EmailSubmittedComponent } from './components/email-submitted/email-submitted.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';

@NgModule({
    imports: [
    CommonModule,
    LoginRegisterRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    LoginRegisterComponent,
    RegisterEmailComponent,
    LoginComponent,
    PrivacyPolicyComponent,
    RegModalComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    EmailVerifiedComponent,
    EmailSubmittedComponent,
    VerifyEmailComponent,
],
    exports: [
        LoginRegisterComponent,
        PrivacyPolicyComponent,
        RegModalComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        EmailVerifiedComponent,
        EmailSubmittedComponent,
        VerifyEmailComponent,
    ],
})
export class LoginRegisterModule {}
